import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    width: String,
    data: Array,
    resultTemplate: String,
    selectionTemplate: String,
    placeholder: String,
    allowClear: Boolean,
    minimumResultsForSearch: { type: Number, default: 0 },
    minimumInputLength: { type: Number, default: 0 }
  }

  connect() {
    this.setup()
  }

  disconnect() {
    this.cleanUp()
  }

  setup() {
    $(this.element).select2(this.buildConfig())
    // jQuery events don't trigger the same way as native events, so we have
    // to listen for the change event and re-dispatch it as a Stimulus event
    this.boundRetrigger = this.retrigger.bind(this)
    $(this.element).on("change.select2", this.boundRetrigger)
  }

  cleanUp() {
    $(this.element).off("change.select2", this.boundRetrigger)
    $(this.element).select2('destroy')
  }

  reset() {
    this.cleanUp()
    this.setup()
  }

  retrigger() {
    // this event will trigger as "select-two:change"
    this.dispatch("change", { details: { renamed: true } })
  }

  buildConfig() {
    const config = {
      minimumResultsForSearch: this.minimumResultsForSearchValue,
      minimumInputLength: this.minimumInputLengthValue,
    }
    if (this.allowClearValue) {
      config.allowClear = this.allowClearValue
    }
    if (this.placeholderValue) {
      config.placeholder = this.placeholder
    }
    if (this.hasUrlValue) {
      config.ajax = {
        url: this.urlValue,
        dataType: 'json',
        delay: 250
      }
    }
    if (this.hasDataValue) {
      config.data = this.dataValue
    }
    if (this.hasWidthValue) {
      config.width = this.widthValue
    }
    // Attached to body, the dropdown renders behind a Bootstrap modal
    const modal = this.element.closest(".modal")
    if (modal) {
      config.dropdownParent = $(modal)
    }
    if (this.hasResultTemplateValue && this.hasSelectionTemplateValue) {
      const formatter = new Formatter(this.resultTemplateValue, this.selectionTemplateValue)
      config.templateResult = (data) => { return $(formatter.formatResult(data)) }
      config.templateSelection = (data) => { return $(formatter.formatSelection(data)) }
    }
    return config
  }

  get placeholder() {
    return this.placeholderValue.startsWith("{") ? JSON.parse(this.placeholderValue) : this.placeholderValue
  }
}

class Formatter {
  constructor(resultTemplate, selectionTemplate) {
    this.rawResultTemplate = resultTemplate
    this.resultTemplate = Handlebars.compile(this.rawResultTemplate)

    this.rawSelectionTemplate = selectionTemplate
    this.selectionTemplate = Handlebars.compile(this.rawSelectionTemplate)
  }

  formatResult(data) {
    return this.resultTemplate(data)
  }

  formatSelection(data) {
    return this.selectionTemplate(data)
  }
}
